import React, { useState, useEffect } from 'react';
import { headerStyle, inputStyle, noteStyle } from '../../constants/styles';
import clsx from 'clsx';
import BasicCard from '../BasicCard';
import CustomButton from '../CustomButton';
import Header from '../Header';
import InputCardItems from '../InputCardItems';
import apiRequest from '../../utils/apiRequest';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Select, { MultiValue } from 'react-select';
import Loader from '../../global/loader';
type newRewardID = {
  rewardId: string;
  rewardTypeId: string;
};
interface TireData {
  tierName: string;
  tierIcon: string;
  tierId: string;
}

interface TierOptions {
  value: string;
  label: string;
}

type RewardForm = {
  typeId?: string;
  rewardId?: string;
  isLimited?: boolean;
  excludedTierIds?: TierOptions[];
  includedTierIds?: TierOptions[];
  isActive?: boolean | string;
  tierSelection?: 'excluded' | 'included';
  status?: 'active' | 'disabled';
};

const FreeShipping = ({ rewardId, rewardTypeId }: newRewardID) => {
  const navigate = useNavigate();

  const [tierOptions, setTierOptions] = useState<TierOptions[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState<RewardForm>({
    typeId: rewardTypeId,
    rewardId: '',
    isLimited: true,
    excludedTierIds: [],
    includedTierIds: [],
    isActive: '',
    tierSelection: 'excluded',
    status: 'active',
  });

  const getRewardByID = async () => {
    setIsLoading(true);
    const params = {
      couponId: rewardId,
    };

    const res = await apiRequest('getRewardById', null, params);
    setIsLoading(false);

    if (res.error) {
      toast.error('Failed to get reward data');
      return -1;
    } else {
      console.log('reward data: ', res.data.data);
      const customerDiscountData =
        res.data?.data?.codeDiscountNode?.codeDiscount;

      const parsedData: RewardForm = {
        rewardId: res.data?.data?.codeDiscountNode?.id,
        status:
          customerDiscountData?.status?.toLowerCase() === 'active'
            ? 'active'
            : 'disabled',
        excludedTierIds:
          customerDiscountData?.excludedTiers &&
          customerDiscountData?.excludedTiers.length > 0
            ? customerDiscountData?.excludedTiers
            : null,
        includedTierIds:
          customerDiscountData?.includedTiers &&
          customerDiscountData?.includedTiers.length > 0
            ? customerDiscountData?.includedTiers
            : null,

        isLimited:
          (customerDiscountData?.excludedTiers &&
            customerDiscountData?.excludedTiers.length > 0) ||
          (customerDiscountData?.includedTiers &&
            customerDiscountData?.includedTiers.length > 0)
            ? true
            : false,

        tierSelection:
          customerDiscountData?.excludedTiers &&
          customerDiscountData?.excludedTiers.length > 0
            ? 'excluded'
            : 'included',
      };

      setFormData((oldData) => ({
        ...oldData,
        ...parsedData,
      }));
    }
  };

  const getAllTierData = async () => {
    const res = await apiRequest('getAllTier');
    console.log(res);

    if (!res?.error && res?.status === 200) {
      const tierData = res?.data.map(
        (val: { tierId: string; tierName: string }) => {
          return {
            value: val?.tierId.toString(),
            label: val?.tierName,
          };
        }
      );

      setTierOptions(tierData);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = event.target;

    if (type === 'checkbox') {
      const isChecked = (event.target as HTMLInputElement).checked;

      setFormData({
        ...formData,
        [name]: isChecked,
        excludedTierIds: [],
        includedTierIds: [],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    // Handle changes for tier selection (include or exclude)
    if (name === 'tierSelection') {
      setFormData((prevData) => ({
        ...prevData,
        tierSelection: value === 'included' ? 'included' : 'excluded',
      }));
    }
  };

  const handleMultiSelectChange = (
    selectedOptions: any[] | MultiValue<{ value: string; label: string }>,
    fieldName: string
  ) => {
    setFormData({
      ...formData,
      [fieldName]: selectedOptions,
    });
  };

  const handleCreate = async () => {
    const formDataToSend = {
      typeId: formData.typeId,
      isLimited: formData.isLimited,
      excludedTierIds:
        formData.excludedTierIds != null &&
        formData.excludedTierIds.length > 0 &&
        formData.tierSelection === 'excluded'
          ? formData.excludedTierIds.map((val) => val?.value)
          : null,
      includedTierIds:
        formData.includedTierIds != null &&
        formData.includedTierIds.length > 0 &&
        formData.tierSelection === 'included'
          ? formData.includedTierIds.map((val) => val?.value)
          : null,
      isActive: formData.status === 'active' ? true : false,
    };

    const res = await apiRequest('createReward', formDataToSend);

    if (res?.error) {
      toast.error('Failed to Save');
    } else {
      toast.success('Saved Successfully');
      console.log(res?.data);
      navigate('/program');
    }
  };

  const handleUpdate = async () => {
    const formDataToSend = {
      rewardId: formData?.rewardId,
      typeId: formData.typeId,
      isLimited: formData.isLimited,
      excludedTierIds:
        formData.excludedTierIds != null &&
        formData.excludedTierIds.length > 0 &&
        formData.tierSelection === 'excluded'
          ? formData.excludedTierIds.map((val) => val?.value)
          : null,
      includedTierIds:
        formData.includedTierIds != null &&
        formData.includedTierIds.length > 0 &&
        formData.tierSelection === 'included'
          ? formData.includedTierIds.map((val) => val?.value)
          : null,
      isActive: formData.status === 'active' ? true : false,
    };

    const res = await apiRequest('updateReward', formDataToSend);

    if (res?.error) {
      toast.error('Failed to Save');
    } else {
      toast.success('Saved Successfully');
      console.log(res?.data);
      navigate('/program');
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    if (rewardId) {
      await handleUpdate();
    } else {
      await handleCreate();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAllTierData();
  }, []);

  useEffect(() => {
    if (rewardId) {
      getRewardByID();
    }
  }, [rewardId]);

  return (
    <>
      {isLoading && <Loader showHide={isLoading} />}
      {!isLoading && (
        <div className='px-5'>
          <CustomButton name='Save' onClick={handleSubmit} />
          <Header title='Free Shipping' />
          <div className='flex w-full gap-3'>
            <div className='w-[60%]'>
              <BasicCard>
                <div className={clsx(headerStyle)}>Customer eligibility</div>

                <div>
                  <InputCardItems>
                    <input
                      type='checkbox'
                      name='isLimited'
                      checked={formData.isLimited}
                      onChange={handleChange}
                      required
                    />
                    <label>Limit to customers based on VIP tiers</label>
                  </InputCardItems>

                  {formData.isLimited && (
                    <>
                      <div className='mb-3'>
                        <input
                          type='radio'
                          name='tierSelection'
                          value='included'
                          checked={formData.tierSelection === 'included'}
                          onChange={handleChange}
                        />
                        <label className={clsx('ml-2', noteStyle)}>
                          <span className='text-bold'>Include</span> Specific
                          VIP tier
                        </label>
                        <Select
                          name='includedTierIds'
                          options={tierOptions}
                          isMulti
                          value={formData?.includedTierIds}
                          isDisabled={formData.tierSelection !== 'included'}
                          onChange={(selectedOptions) =>
                            handleMultiSelectChange(
                              selectedOptions,
                              'includedTierIds'
                            )
                          }
                        />
                      </div>

                      <div className='mb-3'>
                        <input
                          type='radio'
                          name='tierSelection'
                          value='excluded'
                          checked={formData.tierSelection === 'excluded'}
                          onChange={handleChange}
                        />
                        <label className={clsx('ml-2', noteStyle)}>
                          <span className='text-bold'>Exclude</span> Specific
                          VIP tier
                        </label>
                        <Select
                          name='excludedTierIds'
                          options={tierOptions}
                          value={formData?.excludedTierIds}
                          isMulti
                          isDisabled={formData.tierSelection !== 'excluded'}
                          onChange={(selectedOptions) =>
                            handleMultiSelectChange(
                              selectedOptions,
                              'excludedTierIds'
                            )
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
              </BasicCard>
            </div>

            <div className='w-[40%]'>
              <BasicCard>
                <div>
                  <div className={headerStyle}>Summary</div>
                  <div className={noteStyle}>
                    Customer will get free delivery
                  </div>

                  <div className='w-full border my-5' />

                  <div>
                    <div className={headerStyle}>Status</div>

                    <div>
                      <div>
                        <input
                          type='radio'
                          name='status'
                          value='active'
                          checked={formData.status === 'active'}
                          onChange={handleChange}
                        />
                        <label className={clsx('ml-2', noteStyle)}>
                          Active
                        </label>
                      </div>

                      <div>
                        <input
                          type='radio'
                          name='status'
                          value='disabled'
                          checked={formData.status === 'disabled'}
                          onChange={handleChange}
                        />
                        <label className={clsx('ml-2', noteStyle)}>
                          Disabled
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </BasicCard>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FreeShipping;
